import React from 'react'
import { Route } from 'react-router-dom'

import Layers from './layers/'

import Particles from './Particles'
import Overlay from './Overlay'

const Map = () => {
  return (
    <>
      <Route path="/map/:layerID?">
        <Particles />
        <Overlay />
        <Layers />
      </Route>
    </>
  )
}

export default Map
